export const PropertyPhotos = () => {
  return null;
};
